import { FormattedMessage } from 'react-intl';
import React, { useEffect, useState } from 'react';

import Modal from '../Modal/Modal';
import { Heading } from '../Heading/Heading';
import NamedLink from '../NamedLink/NamedLink';
import { bool, func, object } from 'prop-types';
import { getSubscriptionDetailsData } from '../../util/userHelpers';

const SubscriptionWarningModal = props => {
  const [isOpenInternal, setIsOpenInternal] = useState(false);

  const {
    onManageDisableScrolling,
    currentUser,
    isOpen,
    closeExternal,
    enableLimitExceededWarning = true,
  } = props;

  const { metadata } = currentUser?.attributes?.profile || {};

  const { subscription } = metadata || {};

  const { isSubscriptionActive, limitExceeded: limitExceededBase } = getSubscriptionDetailsData(
    subscription
  );
  const limitExceeded = enableLimitExceededWarning && limitExceededBase;

  const headingId = `SubscriptionWarningModal.modalHeading${
    limitExceeded ? 'Exceeded' : 'NotSubscribed'
  }`;
  const descriptionId = `SubscriptionWarningModal.modalDescription${
    limitExceeded ? 'Exceeded' : 'NotSubscribed'
  }`;

  useEffect(() => {
    setIsOpenInternal(isOpen);
  }, [isOpen]);

  useEffect(() => {
    setIsOpenInternal(!isSubscriptionActive || limitExceeded);
  }, [isSubscriptionActive, limitExceeded]);

  return (
    <Modal
      id="SubscriptionWarningModal"
      isOpen={isOpenInternal}
      onClose={() => {
        closeExternal?.();
        setIsOpenInternal(false);
      }}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <Heading as="h3">
        <FormattedMessage id={headingId} />
      </Heading>
      <p>
        <FormattedMessage id={descriptionId} />
      </p>
      <FormattedMessage
        id="SubscriptionWarningModal.pleaseVisit"
        values={{
          link: (
            <NamedLink name="PaymentMethodsPage">
              <FormattedMessage id="SubscriptionWarningModal.modalLink" />
            </NamedLink>
          ),
        }}
      />
    </Modal>
  );
};

SubscriptionWarningModal.propTypes = {
  onManageDisableScrolling: func.isRequired,
  currentUser: object.isRequired,
  isOpen: bool,
  closeExternal: func,
};

export default SubscriptionWarningModal;
